// extracted by mini-css-extract-plugin
module.exports = {"container":"PageNotFound_container__2Jmt7","title":"PageNotFound_title__1QMJ7","goBack":"PageNotFound_goBack__lZtQ7"};